import { useCallback, useState } from 'react'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'

/**
 * Wraps an async save-and-advance action with isSaving state and error toast.
 *
 * Usage:
 *   const { isSaving, run } = useStepAction()
 *   const handleNext = () => run(async () => { await save(); onNext() }, 'Save failed.')
 */
export function useStepAction() {
  const [isSaving, setIsSaving] = useState(false)

  const run = useCallback(async (action: () => Promise<void>, errorMessage?: string) => {
    setIsSaving(true)
    try {
      await action()
    } catch {
      showErrorMessageToast(errorMessage ?? 'Something went wrong. Please try again.')
    } finally {
      setIsSaving(false)
    }
  }, [])

  return { isSaving, run }
}
